import { render, staticRenderFns } from "./SvgPanZoom.vue?vue&type=template&id=806a3476&"
import script from "./SvgPanZoom.vue?vue&type=script&lang=js&"
export * from "./SvgPanZoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/poi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/yanick/work/javascript/vue-svg-pan-zoom/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('806a3476')) {
      api.createRecord('806a3476', component.options)
    } else {
      api.reload('806a3476', component.options)
    }
    module.hot.accept("./SvgPanZoom.vue?vue&type=template&id=806a3476&", function () {
      api.rerender('806a3476', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/SvgPanZoom.vue"
export default component.exports